/**
 * 天为食
 * Created by chenguangpeng on 2018/10/08 14:39.
 */

export default [{
    path: '/delicacy/',
    component: () => import('../components/delicacy/delicacy.vue'),
    meta: {
      title: "天为食"
    }
  }, {
    path: '/cateringbusiness/',
    component: () => import('../components/delicacy/cateringBusiness.vue'),
    meta: {
      title: "餐饮商家"
    }
  },
  {
    path: '/onlineselection/',
    component: () => import('../components/delicacy/onlineSelection.vue'),
    meta: {
      title: "网上甄选"
    }
  }
]
